import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useAbundanceEngineParameters } from '../../hooks/useAbundanceEngineParameters'
import { replaceValues } from '../../utils/replacers'
import { useVariables } from './index'

function VariableDefaults ({ value }) {
  const { mergeVariables } = useVariables()
  const abundanceParams = useAbundanceEngineParameters()
  useEffect(() => {
    const merged = replaceValues(value, abundanceParams)
    mergeVariables(merged)
  }, [mergeVariables, abundanceParams, value])

  return null
}

VariableDefaults.propTypes = {
  value: PropTypes.object
}

export default VariableDefaults
